import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import ProfileHeader from "../Headers/ProfileHeader";
import {delAllTeamAssets, delTeamAsset, getTeamAssets} from "../../lib/api";
import $ from 'jquery';
import "bootstrap";
import {Button, OverlayTrigger} from "react-bootstrap";
import {TrashButton} from "../Shared/Buttons";
import {Link} from "react-router-dom";

function deleteAsset(teamAsset: any, name: string, refreshTeamAssets: () => void, setError: (error: any) => void) {
  const answer = window.confirm(`Delete ${name}? This cannot be undone`)
  if (answer) {
    setError(null);
    delTeamAsset(teamAsset).then(response => {
      if (!response.ok) {
        response.json().then(json => {
          setError(json?.error);
        })
      }
      refreshTeamAssets();
    });
  }
}

function deleteAllAssets(team: any, refreshTeamAssets: () => void, setError: (error: any) => void) {
  const answer = window.confirm(`Delete all assets? This cannot be undone`)
  if (answer) {
    setError(null);
    delAllTeamAssets(team).then(response => {
      if (!response.ok) {
        response.json().then(json => {
          setError(json?.error);
        })
      }
      refreshTeamAssets();
    });
  }
}


function Asset(props: { asset: any, refreshTeamAssets: () => void, setError: (error: any) => void }) {
  const {asset, refreshTeamAssets, setError} = props;
  let name = '';
  let href = null;
  if (asset["assetType"] === "SketchfabModel") {
    name = asset["asset"]["sketchfabAttributes"]["name"];
    href = asset["asset"]["sketchfabAttributes"]["viewerUrl"];
  } else if (asset["assetType"] === "UserFile") {
    name = asset["asset"]["name"];
    href = asset["asset"]["url"];
  } else if (asset["assetType"] === "OpenseaAsset") {
    name = asset["asset"]["openseaAttributes"]["name"] || `${asset["asset"]["assetContractAddress"]}/${asset["asset"]["tokenId"]}`;
    href = `https://opensea.io/assets/${asset["asset"]["assetContractAddress"]}/${asset["asset"]["tokenId"]}`;
  } else if (asset["assetType"] === "UnsplashImage") {
    name = asset["asset"]["imageAttributes"]["altDescription"] || asset["asset"]["imageAttributes"]["user"]["name"] || asset["asset"]["unsplashId"];
    href = `https://unsplash.com/photos/${asset["asset"]["unsplashId"]}`;
  } else if (asset["assetType"] === "EpidemicTrack") {
    name = asset["asset"]["epidemicAttributes"]["title"]
    href = asset["asset"]["url"]
  }
  return (
    <>
      <div className="file row py-2 d-none d-flex d-lg-none">
        <div className="col-12">
          <ul>
            <li>{asset["geo"]} </li>
            <li>{asset["assetType"]}</li>
            {asset["assetType"] === "EpidemicTrack" ?
              <>
                <li>
                  {name}
                </li>
                <li>
                  <audio controls className="d-inline-block">
                    <source src={href} type="audio/mpeg"/>
                  </audio>
                </li>
              </>
              : href ? <li><a className="underline" target="_blank" href={href} rel="noopener">{name}</a></li> : null}
            <li><TrashButton onClick={() => deleteAsset(asset, name, refreshTeamAssets, setError)} visible={true}/></li>
          </ul>
        </div>
      </div>
      <div className="file row py-2 d-none d-lg-flex">
        <div className="col-2">
          {asset["geo"]}
        </div>
        <div className="col-2">
          {asset["assetType"]}
        </div>
        <div className="col-7">
          {asset["assetType"] === "EpidemicTrack" ?
            <span className="align-top">
              <span className="align-top">
                <audio controls controlsList="nodownload" className="d-inline-block">
                  <source src={href} type="audio/mpeg"/>
                </audio>
              </span>
              <span className="ml-2">{name}</span>
            </span>
            : href ? <a className="underline" target="_blank" href={href} rel="noopener">{name}</a> : null}
        </div>
        <div className="col-1">
          <TrashButton onClick={() => deleteAsset(asset, name, refreshTeamAssets, setError)} visible={true}/>
        </div>
      </div>
    </>
  );
}

function TeamAssetList(props: { teamAssets: { teamAssets: any[] }, refreshTeamAssets: () => void, setError: (error: any) => void }) {
  const {teamAssets, refreshTeamAssets, setError} = props;
  const list = teamAssets["teamAssets"].map((asset: any) => {
    return <Asset asset={asset} refreshTeamAssets={refreshTeamAssets} setError={setError} key={asset["id"]}/>
  });

  if (teamAssets["teamAssets"].length === 0) {
    return <div className="text-center">None</div>;
  }

  return (
    <>{list}</>
  );
}

function TeamAssets(props: { cognitoUser: any, realvrUser: any }) {
  const {cognitoUser, realvrUser} = props;
  // @ts-ignore
  const {orgId, teamId} = useParams();
  const {orgs} = realvrUser.user;
  const org = orgs?.find((org: any) => org.id === orgId)
  const team = org?.teams.find((team: any) => team.id === teamId)
  const [teamAssets, setTeamAssets] = useState({teamAssets: []});
  const [error, setError] = useState(null);

  const linkToHome = `/org/${org.id}/team/${team.id}`;
  const homeImage = org.imageUrl;
  useEffect(() => {
      refreshTeamAssets();
    }, []
  )

  function refreshTeamAssets() {
    getTeamAssets(team).then(response => {
      if (response.ok) {
        response.json().then(json => {
          setTeamAssets(json);
        });
      }
    });
  }

  const errorMessage = error ?
    (
      <div className="row error text-center p-4">
        <div className="col">
          Error: {(error as any)?.message}
        </div>
      </div>
    )
    : null;

  return (
    <>
      <ProfileHeader cognitoUser={cognitoUser} title={team.name} linkToHome={linkToHome} image={homeImage}/>
      <section className="container main library p-4 rounded">
        <div className="row">
          <div className="col-3 pl-0">
            <button className="btn btn-primary" type="button">
              <Link to={linkToHome}>Back</Link>
            </button>
          </div>
          <div className="col-6 pb-2 text-center instructions">
            <span className="text-nowrap">Assets in this Villa</span><br/>
            <span>You can delete individual assets or Delete All</span>
          </div>
          <div className="col-3 pl-0 text-right">
            <Button className="btn btn-primary" type="button"
                    onClick={() => deleteAllAssets(team, refreshTeamAssets, setError)}>
              Delete All
            </Button>
          </div>
        </div>
        {errorMessage}
        <div className="row">
          <div className="col">
            <TeamAssetList teamAssets={teamAssets} refreshTeamAssets={refreshTeamAssets} setError={setError}/>
          </div>
        </div>

      </section>

    </>);
}

export default TeamAssets;
